// Origineel: client/imports/ui/Admin/AdminState.tsx (de context en `useAdminState`).
import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';
import type { Asset, AssetIncidentMalfunctionData } from '@ame/shared';

/**
 * De gedeelde staat van het adminpaneel. Hij staat om de hele app heen (zie `Providers.tsx`),
 * zoals in het origineel, zodat hij een wissel van route overleeft. Niet in het origineel:
 * zonder `tasksProcessed` en `tasksThatCanBeGiven`, want de nieuwe taken deelt de server uit
 * (`startNieuweRonde`).
 */
export type AdminState = {
  /** De taken op tafel volgens het spel; na "Alles verwerkt" leeg tot het spel weer wijzigt. */
  tasksOnTable: string[];
  /**
   * Storingen en incidenten per machine zoals ze de volgende ronde ingaan: die van het spel,
   * met de gegooide dobbelstenen erop zolang de spelleider de nieuwe ronde voorbereidt. Niet
   * in het origineel: de worp zelf staat op de server (`game.voorbereiding`); dit is er alleen
   * een afgeleide van, dus opnieuw laden kost niets.
   */
  assets: Record<Asset, AssetIncidentMalfunctionData>;
};

export type AdminStateWaarde = {
  state: AdminState;
  setState: Dispatch<SetStateAction<AdminState>>;
};

export const AdminStateContext = createContext<AdminStateWaarde | null>(null);

export function useAdminState(): AdminStateWaarde {
  const waarde = useContext(AdminStateContext);
  if (!waarde) throw new Error('useAdminState must be used within a AdminStateContext');
  return waarde;
}
